import React, { useState, useEffect } from "react";
import "../CSS/Style.css";
import axios from "axios";
import Header from "./Header";
import Pagination from "./Pagination";

const generateRandomPassword = () => {
  const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789@#$!";
  return Array.from({ length: 8 }, () => chars.charAt(Math.floor(Math.random() * chars.length))).join("");
};

const Technician = () => {
  const [token, setToken] = useState("");
  const [message, setMessage] = useState("");
  const [technician, setTechnician] = useState({
    name: "",
    mobile: "",
    email: "",
    aadhar_number: "",
    password: generateRandomPassword(),
  });

  const [technicians, setTechnicians] = useState([]);
  const [loading, setLoading] = useState(false);
  const [technicianMessage, setTechnicianMessage] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10; 

  useEffect(() => {
    const storedToken = sessionStorage.getItem("token");
    if (!storedToken) {
      window.location.href = "/signin";
    } else {
      setToken(storedToken);
      validateUserToken(storedToken);
    }
    fetchTechnicians();
  }, []);

  const validateUserToken = async (storedToken) => {
    try {
      const config = { headers: { Authorization: `Bearer ${storedToken}` } };
      const res = await axios.get("https://api.mahirefrigeration.com/api/validateToken", config);
      if (res.data === "User validation failed") {
        sessionStorage.clear();
        window.location.href = "/signin";
      }
    } catch (error) {
      console.error("Token validation failed", error);
    }
  };

  const fetchTechnicians = async () => {
    setLoading(true);
    try {
      const token = sessionStorage.getItem("token");
      const config = { headers: { Authorization: `Bearer ${token}` } };
      const response = await axios.get("https://api.mahirefrigeration.com/api/get_all_technicians", config);
      if (response.data.success) {
        setTechnicians(response.data.technicians.reverse() || []);
      } else {
        setTechnicianMessage(response.data.message);
      }
    } catch (error) {
      setTechnicianMessage("Failed to fetch technicians. Try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    setTechnician({ ...technician, [e.target.name]: e.target.value });
  };

  const createTechnician = async (e) => {
    e.preventDefault();

    if (!technician.name || !technician.mobile || !technician.email || !technician.aadhar_number) {
      setMessage("All fields are required.");
      return;
    }

    const config = { headers: { Authorization: `Bearer ${token}` } };

    try {
      const res = await axios.post("https://api.mahirefrigeration.com/api/create_technician", technician, config);
      setMessage(res.data.message);

      if (res.data.success) {
        setTechnician({
          name: "",
          mobile: "",
          email: "",
          aadhar_number: "",
          password: generateRandomPassword(),
        });
        fetchTechnicians(); // Refresh the list after creation
      }
    } catch (err) {
      setMessage("Error creating technician. Try again.");
    }
  };

  const indexOfLastTechnician = currentPage * rowsPerPage;
  const indexOfFirstTechnician = indexOfLastTechnician - rowsPerPage;
  const currentTechnicians = technicians.slice(indexOfFirstTechnician, indexOfLastTechnician);

  return (
    <>
      <Header />
      <div className="first_sec_ran">
        <div className="container">
        <div className="row my-4" style={{  }}>
          
          {/* Left Side: Create Technician Form */}
          <div className="col-md-6 mt-4">
            <div className="container">
              <form onSubmit={createTechnician}>
                <div className="parent" style={{ position: "relative", height: "" }}>
                  {/* <div className="child_class p-4" style={{ border: "1px solid #252936", borderRadius: "6px", width: "100%", height: "auto" }}> */}
                  <div className="box" style={{ width:"100%",flex: "2", padding: "20px", background: "#fff", borderRadius: "8px", boxShadow: "0px 4px 6px rgba(0,0,0,0.1)",height:"470px",overflow:"auto"}}>
                    <h2 style={{ color: "skyblue" }}>Create A Technician</h2>

                    <div className="form__group field">
                    <label className="form__label">Name</label>
                      <input type="text" className="form__field" placeholder="Name" name="name" value={technician.name} onChange={handleChange} required />
                    </div>

                    <div className="form__group field">
                    <label className="form__label">Aadhar Number</label>
                      <input type="number" className="form__field" placeholder="Aadhar Number" name="aadhar_number" value={technician.aadhar_number} onChange={handleChange} required />
                    </div>

                    <div className="form__group field">
                    <label className="form__label">Mobile</label>
                      <input type="number" className="form__field" placeholder="Mobile" name="mobile" value={technician.mobile} onChange={handleChange} required />
                    </div>

                    <div className="form__group field">
                    <label className="form__label">Email</label>
                      <input type="email" className="form__field" placeholder="Email" name="email" value={technician.email} onChange={handleChange} required />
                    </div>

                    <div className="form__group field">
                    <label className="form__label">Password</label>
                      <input type="text" className="form__field" placeholder="Generated Password" name="password" value={technician.password} readOnly />
                    </div>
                    <div class="form__group field">
                    <button type="submit" className="btn" style={{ minWidth: "50%", border: "1px solid skyblue", color: "#000" }}>
                      Create Technician
                    </button>
                    <br/>
                    <p style={{ color: "#000" }}>{message && <span className="message">{message}</span>}</p>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>

          {/* Right Side: List of Technicians */}
          <div className="col-md-6 mt-4">
            <div className="container">
              <div className="parent" style={{ position: "relative", height: "" }}>
                {/* <div className="child_class p-4" style={{ border: "1px solid #252936", borderRadius: "6px", width: "100%", height: "auto" }}>  */}
                <div className="box" style={{ width:"100%",flex: "2", padding: "20px", background: "#fff", borderRadius: "8px", boxShadow: "0px 4px 6px rgba(0,0,0,0.1)",height:"470px",overflow:"auto"}}>
                  <h2 style={{ color: "skyblue" }}>All Technicians</h2>
                  {technicianMessage && <p>{technicianMessage}</p>}

                  {technicians.length > 0 ? (
                    <div className="table-wrapper" style={{ overflowX: "scroll", minWidth: "100%" }}>
                      <table className="table">
                        <thead>
                          <tr>
                            <th>Name</th>
                            <th>Email</th>
                            <th>Mobile</th>
                          </tr>
                        </thead>
                        <tbody>
                          {currentTechnicians.map((technician, index) => (
                            <tr key={index}>
                              <td>{technician.name}</td>
                              <td>{technician.email}</td>
                              <td>{technician.mobile}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  ) : (
                    <p style={{color:"#000"}}>No technician found</p>
                  )}

                  {/* <div className="pagination">
                    {[...Array(Math.ceil(technicians.length / rowsPerPage)).keys()].map((number) => (
                      <button key={number} onClick={() => setCurrentPage(number + 1)} className={currentPage === number + 1 ? "active" : ""}>
                        {number + 1}
                      </button>
                    ))}
                  </div> */}
                  <Pagination
                 currentPage={currentPage}
                 totalItems={technicians.length}
                 itemsPerPage={rowsPerPage}
                 onPageChange={setCurrentPage}
                 />

                </div>
              </div>
            </div>
          </div>

        </div>
        </div>
      </div>
    </>
  );
};

export default Technician;
